import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import ResendVerificationLink from "@/components/ResendVerificationLink";
import { useAuth } from "@/context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [resendEmail, setResendEmail] = useState("");
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(async () => {
        await refreshUser();
        setStatus("success");
      })
      .catch(() => setStatus("error"));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="section-container py-16 flex items-center justify-center">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8 shadow-sm text-center">
          {status === "verifying" && <p className="text-[#64748B]">Verifying your email...</p>}
          {status === "success" && (
            <>
              <h1 className="text-xl font-black text-[#003366] mb-2">Email Verified</h1>
              <p className="text-[#64748B] text-sm mb-6">You're all set. You can now claim ZIP codes, post jobs, and use AI tools.</p>
              <Link to="/portal" className="btn-action inline-block">Go to Partner Portal</Link>
            </>
          )}
          {status === "error" && (
            <>
              <h1 className="text-xl font-black text-[#003366] mb-2">Link Invalid or Expired</h1>
              <p className="text-[#64748B] text-sm mb-4">Enter your email to get a new verification link.</p>
              <input
                type="email"
                value={resendEmail}
                onChange={(e) => setResendEmail(e.target.value)}
                placeholder="you@yourbusiness.com"
                className="input-field mb-3"
              />
              <ResendVerificationLink email={resendEmail} className="btn-action !py-2 !px-4 !text-sm inline-block" />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
